import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HOME_PAGE } from '../routing/app-paths';
import { LinkRegistry } from './link-registry';

/** Sends `/` to the home page's route once it is built here; until then `/` shows the shell with no page (EP-33). */
export const homeGuard: CanActivateFn = () => {
  const link = inject(LinkRegistry).link(HOME_PAGE);

  return link.kind === 'route' ? inject(Router).parseUrl(link.path) : true;
};
